/*
 * wip ripple effect
 */
;(function ($, window, document, undefined) {
    // Create the defaults once
    const pluginName = 'fuseRipple',
        defaults = {
            duration: 300,//ms
            fromCenter: false
        };

    const TagWrapper = {
        // Wrap <input> tag so it can perform the effect
        input: function (element) {
            const parent = element.parentNode;

            // If input already have parent just pass through
            if (parent.tagName.toLowerCase() === 'span' && parent.classList.contains('fuse-ripple-ready')) {
                return;
            }

            // Put element class and style to the specified parent
            const wrapper = document.createElement('span');
            wrapper.className = element.className + ' fuse-ripple-input-wrapper';
            element.className = 'fuse-ripple-input';

            // Put element as child
            parent.replaceChild(wrapper, element);
            wrapper.appendChild(element);

            // Apply element color and background color to wrapper
            /*  var elementStyle = window.getComputedStyle(element, null);
             var color = elementStyle.color;
             var backgroundColor = elementStyle.backgroundColor;

             wrapper.setAttribute('style', 'color:' + color + ';background:' + backgroundColor);
             element.setAttribute('style', 'background-color:rgba(0,0,0,0);');*/
        },

        // Wrap <img> tag so it can perform the effect
        img: function (element) {
            const parent = element.parentNode;

            // If input already have parent just pass through
            if (parent.tagName.toLowerCase() === 'span' && parent.classList.contains('fuse-ripple-ready')) {
                return;
            }

            // Put element as child
            const wrapper = document.createElement('span');
            parent.replaceChild(wrapper, element);
            wrapper.appendChild(element);

        }
    };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;

        // the default options for future instances of the plugin
        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype = {
        init: function () {
            const body = document.body;
            const self = this;
            var el;

            el = self.element;

            const tagName = self.element.tagName.toLowerCase();

            if (['input', 'img'].indexOf(tagName) !== -1) {
                TagWrapper[tagName](self.element);
                el = self.element.parentElement;
            }

            if (!$(el).hasClass('fuse-ripple-ready')) {
                $(el).addClass('fuse-ripple-ready');
            }

            el.addEventListener('mousedown', triggerRippleEvent);

            function triggerRippleEvent(ev) {
                ev.stopPropagation();
                self.triggerRipple(el, self.options, ev);
            }
        },

        triggerRipple: function (element, options, ev) {
            const el = $(element);

            // Remove the previous ripple before starting to a new one
            const rippleExist = el.find('.fuse-ripple').length > 0;

            if (rippleExist) {
                el.find('.fuse-ripple').remove();
            }

            // Create ripple
            const ripple = $('<div class="fuse-ripple">');

            // Get click coordinate and element width
            const pos = el.offset();
            var relativeY = 0;
            var relativeX = 0;

            // Support for touch devices
            if ('touches' in ev && ev.touches.length) {
                relativeY = (ev.touches[0].pageY - pos.top);
                relativeX = (ev.touches[0].pageX - pos.left);
            }
            //Normal case
            else {
                relativeY = (ev.pageY - pos.top);
                relativeX = (ev.pageX - pos.left);
            }

            const elWidth = el.outerWidth();
            const elHeight = el.outerHeight();

            // Calculate ripple diameter
            const surfaceDiameter = Math.sqrt(Math.pow(elWidth, 2) + Math.pow(elHeight, 2));

            // Calculate ripple initial size
            const initialSize = (Math.max(elWidth, elHeight)) * 0.6;

            const scale = 'scale(1)';
            const translateX = parseInt(relativeX - (initialSize / 2));
            const translateY = parseInt(relativeY - (initialSize / 2));
            var translate = 'translate(' + translateX + 'px ,' + translateY + 'px)';

            if (options.fromCenter) {
                translate = 'translate(' + parseInt(elWidth * 0.2) + 'px ,' + parseInt(elHeight * 0.2) + 'px)';
            }

            const transform = scale + ' ' + translate;
            const scaleRatio = surfaceDiameter / initialSize;
            const endScale = 'scale(' + scaleRatio + ')';
            const endTranslate = 'translate(' + (elWidth - initialSize) * .5 / scaleRatio + 'px ,' + (elHeight - initialSize) * .5 / scaleRatio + 'px)';
            const endTransform = endScale + ' ' + endTranslate;
            const endTransition = 'opacity ' + options.duration + 'ms linear, transform  ' + options.duration + 'ms cubic-bezier(0.4, 0, 0.2, 1)';

            if (options.fromCenter) {
            }

            const startStyle = {
                width: initialSize + 'px',
                height: initialSize + 'px',
                transform: transform,
                opacity: 1
            };

            const endStyle = {
                opacity: '0',
                transform: endTransform,
                transition: endTransition,
            };

            $(ripple).css(startStyle);
            el.append(ripple);

            setTimeout(function () {
                $(ripple).css(endStyle);
            });

            setTimeout(function () {
                el.find(ripple).remove();
            }, options.duration);
        }
    };

    // Plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);
